document.addEventListener('DOMContentLoaded', () => {
	// Select the product item element from the form
	const productItem = document.getElementById('product-form-item');
	const paymentButton = document.querySelector('.shopify-payment-button');

	// Push data to the data layer when the product item page is loaded
	pushDataLayer('view_item', productItem, 'isProductItem');

	const addToCartButton = document.getElementById('add-to-cart');

	addToCartButton.addEventListener('click', () => {
		const itemQuantity = document.querySelector('.product-form__input--quantity').value;
		addToCartButton.setAttribute('data-cart-type', 'add_to_cart');
		productItem.setAttribute('data-item-quantity', itemQuantity);
		pushDataLayer('add_to_cart', productItem, 'isProductItem');
	});
	if (!paymentButton) {
		return;
	}
	paymentButton.addEventListener('click', function (e) {
		const itemQuantity = document.querySelector('.product-form__input--quantity').value;
		productItem.setAttribute('data-cart-type', 'payment_button');
		productItem.setAttribute('data-item-quantity', itemQuantity);
		pushDataLayer('add_to_cart', productItem, 'isProductItem');
	});
});
